module.exports = __webpack_public_path__ + "img/xgq.e058ec67.png";